'use strict';
import React from 'react';
import NavBar from '../../components/navBar';
import SideMenu from '../../components/sideMenu';
import Loading from '../../components/loading';
import filterAction from '../../actions/filterAction';
import filterStore from '../../stores/filterStore';
import menuAction from '../../actions/menuAction';
import contractorAction from '../../actions/contractorAction';
import contractorStore from '../../stores/contractorStore';
import ContractorCondoForm from './contractorCondoForm';

class ContractorForm extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.state = {
            processingFilter: filterStore.getState().processing,
            condos: filterStore.getState().condos,
            iniLoadCondo: filterStore.getState().iniLoadCondo,

            contractor: contractorStore.getState().contractor,
            processing: contractorStore.getState().processing,
            warningMsg: "",
        };
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        statusTxt: ["Active", "In-Active", "Terminated","Ad hoc","Unknown"],

    };
    componentDidMount() {
        contractorStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        contractorAction.clear();
        menuAction.pageNumber({ selectedActivity: -1, selectedCategory: 1 });
        if (!this.state.iniLoadCondo && !this.state.processingFilter) {
            filterAction.processing(true);
            filterAction.getCondoList();
        }

        contractorAction.processing(true);
        contractorAction.getContractor(this.props.match.params.id);
    }
    componentWillUnmount() {
        contractorStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
    onChange(state) {
        this.setState({
            contractor: state.contractor,
            processing: state.processing,
        });
    }
    onFilterChange(state) {
        this.setState({
            processingFilter: state.processing,
            iniLoadCondo: state.iniLoadCondo,
            condos: state.condos,
        });
    }
    handleCheck(e) {
        let checked = e.target.checked;

        let s = this.state.contractor;
        s.isGSTRegister = checked;
        contractorAction.contractor(s);
    }
    handleEdit(e) {
        let index = parseInt(e.target.getAttribute('data-index'));

        let value = e.target.value;
        let s = this.state.contractor;

        switch (index) {
            case 0:
                s.contractorName = value;
                break;
            case 1:
                s.telephone = value;
                break;
            case 2:
                s.fax = value;
                break;
            case 3:
                s.contractorEmail = value;
                break;
            case 4:
                s.contactName = value;
                break;
            /*    
            case 5:
                s.status = parseInt(value);
                break;
            */
            case 6:
                s.streetName = (value);
                break;
            case 7:
                s.blkNo = (value);
                break;
            case 8:
                s.unitNo = (value);
                break;
            case 9:
                s.postal = parseInt(value);
                break;
        }

        contractorAction.contractor(s);
    }
    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 2) {
            this.props.history.push('/contractorSetting');
        } else if (index == 0) {
            if (this.props.processing) return;

            contractorAction.processing(true);
            contractorAction.updateContractor(this.state.contractor);
        } else if (index == 1) {
            if (this.props.processing) return;

            contractorAction.processing(true);
            contractorAction.removeContractor(this.props.match.params.id);
        }
    }
    render() {
        let s = this.state.contractor;


        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <Loading {...this.props} processing={this.state.processing || this.state.processingFilter} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="contractorSet-form">
                            <div className="row">
                                <h3><b>Edit Contractor</b></h3>
                                <div className="col-md-6">
                                    <h4><b>Contractor Details</b></h4>
                                    <div className="form-group">
                                        <label htmlFor="contractorName">Name of Contractor</label>
                                        <input type="text" className="form-control" value={s.contractorName} id="contractorName"
                                            placeholder="Type the name of contractor here" data-index="0" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="telephone">Telephone</label>
                                        <input type="number" className="form-control" value={s.telephone} id="telephone"
                                            placeholder="e.g. 9XXX XXXX" data-index="1" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="fax">Fax</label>
                                        <input type="number" className="form-control" value={s.fax} id="fax"
                                            placeholder="e.g. 9XXX XXXX" data-index="2" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contractorEmail">Contractor Email</label>
                                        <input type="email" className="form-control" value={s.contractorEmail} id="contractorEmail"
                                            placeholder="Type contractor email here" data-index="3" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contactName">Contact Name</label>
                                        <input type="text" className="form-control" value={s.contactName} id="contactName"
                                            placeholder="Type contact name here" data-index="4" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="totalAmount">Total Contract Amount (SGD)</label>
                                        <input type="text" className="form-control" value={s.totalAmount} id="totalAmount"
                                            disabled={true} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="streetName">Street Name/Building Name</label>
                                        <input type="text" className="form-control" value={s.streetName} id="streetName" data-index="6"
                                            onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="blkNo">Block No.</label>
                                        <input type="text" className="form-control" value={s.blkNo} id="blkNo" data-index="7"
                                            onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="unitNo">Unit No.</label>
                                        <input type="text" className="form-control" value={s.unitNo} id="unitNo" data-index="8"
                                            onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="postal">Postal</label>
                                        <input type="number" className="form-control" value={s.postal} id="postal" data-index="9"
                                            onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label>
                                                <input type="checkbox"
                                                    onChange={this.handleCheck} checked={s.isGSTRegister} />
                                                <span className="checkmark"></span>
                                                GST registered Company
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <ContractorCondoForm contractor={s} condos={this.state.condos} />
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="warning">{this.state.warningMsg}</div>
                                    <button type="button" className="btn btn-warning us-cr"
                                        data-index="0" onClick={this.handleClick}>Update</button>
                                    <button type="button" className="btn btn-default us-cr"
                                        data-index="2" onClick={this.handleClick}>Cancel</button>
                                </div>
                                <div className="clear"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ContractorForm;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/contractorForm.js